import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { Title } from '@angular/platform-browser';
import { UserService } from '../shared/user.service';
import { ErrorHandler } from '../shared/ErrorHandler';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  title: string;
  AllProjectDetails: any;
  Project: any;
  Id: any;
  district: any;
  itemsPerPage: number = 10;
  currentPage: number = 1;
  totalItems: number;
  TotalPropertiesCount: number;
  AvailableCount: number;
  BlockedCount: number;
  data: any;
  userRole: any;
  DistrictDisplay: string
  projectdetails: any = {};
  propertyall: any;
  AllottedCount: any;
  Alert: any = [];
  AlertReceived:any=[];
  AlertEscalated: any=[];
  AlertResolved:any=[];
  OtherAvailableCount:any=[];
  propertylist:any=[];
  acc: any;

  constructor(private userService: UserService, private errorHandler: ErrorHandler,private router: Router) {
  }

  ngOnInit() {
    this.Id = 6;
    this.AllProjectDetailss(this.itemsPerPage, 1, this.Id);
    this.title = "Vacant Properties Status";
    this.userRole = localStorage.getItem('userRole');
    this.LoginDetails();
    //this.GetAlertSent()
    // this.GetAlertReceived()
    //this.GetAlertEscalated()

  }


  pageChanged(pageNumber: number) {
    this.AllProjectDetailss(this.itemsPerPage, pageNumber, this.Id);
  }

  itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
    this.AllProjectDetailss(this.itemsPerPage, pageNo, this.Id);
  }

  getid(id, district) {
    debugger;
    this.Id = id;
    this.district = district;
    // this.title="Vacant Properties Status for " + this.district;

    this.AllProjectDetailss(this.itemsPerPage, 1, id)
  }

  AllProjectDetailss(itemsPerPage: number, pageNo: number, id) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.AllProjectDetails(itemsPerPage, pageNo, id)
      .subscribe(
        (data: any) => {
          this.AllProjectDetails = data.projectsModels;
          this.totalItems = data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
          this.GetTotalPropertiesCount();
          this.GetVacantPropCount();
          this.GetBlockedPropCount();
          this.GetAllottedPropCount();
          this.GetOtherAvailablePropCount();
          document.getElementById('loader-spinner').style.display = "none";
        }, (error: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  GetTotalPropertiesCount() {
    for (let i = 0; i < this.AllProjectDetails.length; i++) {
      this.TotalPropertiesCount = this.AllProjectDetails[i].TotalPropertiesCount;
      break;
    }
  }

  //LoginDetails
  LoginDetails() {
    this.userService.LoginDetails()
      .subscribe(
        (data: any) => {
          if (data == '' || data == null || data == 'MDNA') {
            this.DistrictDisplay = 'Karnataka';
          }
          else {
            this.DistrictDisplay = data;
          }
          console.log('District');
          console.log(this.DistrictDisplay)
          document.getElementById('loader-spinner').style.display = "none";
        }, (error: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }


  GetVacantPropCount() {
    for (let i = 0; i < this.AllProjectDetails.length; i++) {
      this.AvailableCount = this.AllProjectDetails[i].AvailableCount;
      break;
    }
  }

  GetBlockedPropCount() {
    for (let i = 0; i < this.AllProjectDetails.length; i++) {
      this.BlockedCount = this.AllProjectDetails[i].BlockedCount;
      break;
    }
  }

  GetAllottedPropCount() {
    for (let i = 0; i < this.AllProjectDetails.length; i++) {
      this.AllottedCount = this.AllProjectDetails[i].AllottedCount;
      break;
    }
  }

  GetOtherAvailablePropCount() {
    for (let i = 0; i < this.AllProjectDetails.length; i++) {
      this.OtherAvailableCount = this.AllProjectDetails[i].OtherAvailableCount;
      break;
    }
  }

  GetPropertiesforDashboard(PD_ID,Type,index) {
   
    this.acc = index;  
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAvailablePropertylistForTheId(PD_ID,Type);
    this.data.subscribe(
      (response: any) => {
        //this.projectdetails = response;
        this.propertyall = response.PropertyRegister;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetProjectDetailforDashboard(PD_ID,Type) {  
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetProjectDetailforDashboard(PD_ID,Type);
    this.data.subscribe(
      (response: any) => {
        this.projectdetails = response;
        this.propertylist = response.PropertyRegister;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  Paym() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.Pay();
    this.data.subscribe(
      (response: any) => {
        swal('success!', "Please upload file less than 2mb", 'success');
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  Pay() {
    debugger;
    window.open("http://localhost:14080/Esign/Payment.aspx");
    // document.getElementById('loader-spinner').style.display = "block";
    // this.data = this.userService.Payment();
    // this.data.subscribe(
    //   (response: any) => {
    //     // this.Alert = response;
    //     document.getElementById('loader-spinner').style.display = "none";
    //   }, (error) => {
    //     document.getElementById('loader-spinner').style.display = "none";
    //     this.errorHandler.HandlerError(error);
    //   });
  }

  GetAlertSent() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAlert();
    this.data.subscribe(
      (response: any) => {
        this.Alert = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }

  GetAlertReceived() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAlertReceived();
    this.data.subscribe(
      (response: any) => {
        this.AlertReceived = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }

  GetAlertEscalated() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAlertEscalated();
    this.data.subscribe(
      (response: any) => {
        this.AlertEscalated = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }

  GetAlertResolved() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAlertResolved();
    this.data.subscribe(
      (response: any) => {
        this.AlertResolved = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }

  

}


// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts